<template>
  <div v-if="content">
    <h5>{{ content.headline }}</h5>

    <div v-html="content.description.html" />
  </div>
  <div v-else-if="config.richText" v-html="config.richText" />
  <div v-else>
    {{ $te(config.id) ? $t(config.id) : config.id }}
  </div>
</template>

<script>
import teaserContentBySlugQuery from '~/domains/application/__gql__/queries/teaserContentBySlug.gql'

export default {
  name: 'DXContentItemAdapter',
  components: {},
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      content: null,
    }
  },

  mounted() {
    this.fetchContent()
  },

  methods: {
    async fetchContent() {
      const { data } = await this.$apolloProvider.clients.cms.query({
        query: teaserContentBySlugQuery,
        variables: {
          slug: this.config.id,
          locales: [this.$i18n.locale],
        },
        fetchPolicy: 'no-cache',
      })

      if (data?.teaserContent) {
        this.content = data.teaserContent
      } else {
        this.content = null
      }
    },
  },
}
</script>
